import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";
import dul9_150gm from "../images/dul9.150gm.jpg";
import Dul9_650gm from "../images/dul9.650gm.jpg";
import Dul10_310gm from "../images/dul10.310gm.jpg";
import Dul11_290gm from "../images/dul11.290gm.jpg";
import Dul16_690gm from "../images/dul14.690gm.jpg";
import Dul4_140gm from "../images/dul4.140gm.jpg";


import Dul15gm from "../images/dul15.00gm.jpg";
import Dul6_460gm from "../images/dul16.460gm.jpg";



import Dul10_680gm from "../images/dul10.680gm.jpg";

import Dul4_680gm from "../images/dul4.680gm.jpg";



import Dul12_490g from "../images/dul 12.490gm.jpg";
import Dul3_430gm from "../images/dul3.430gm.jpg";
import Dul4_190gm from "../images/dul4.190gm.jpg";

import Dulnew4_420gm from "../images/dul4.420gm.jpg";



import Dul4_640gm from "../images/dul4.640gm.jpg";
import Dul4_780gm from "../images/dul4.780gm.jpg";
import Dul5_120gm from "../images/dul5.120gm.jpg";


import Dulnew4_800gm from "../images/dul4.800gm.jpg";
import Dul4_830gm from "../images/dul4.830gm.jpg";
import Dul4_970gm from "../images/dul4.970gm.jpg";

import Dulnew5_380gm from "../images/dul5.380gm.jpg";
import Dul5_450gm from "../images/dul5.450gm.jpg";
import Dul5_550gm from "../images/dul5.550gm.jpg";
import Dul5_570gm from "../images/dul5.720gm.jpg"

import Dulnew9_810gm from "../images/dul9.810gm.jpg";
import Dul10_090gm from "../images/dul10.090gm.jpg";
import Dul10_130gm from "../images/dul10.450gm.jpg";
import Dul10_620gm from "../images/dul10.620gm.jpg";





import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'




import Header from "../inc/Header";

function Dulpage() {
    return (
        <div>

            <Header />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="maroon" />
            <div className='colorbacklockt'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Dul</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={dul9_150gm} className="card-img-top" alt="dul" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Dul </h5>
                                                <p className="card-text">Weight: 9.150gm</p>
                                                <p className="card-text mb-2">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Dul10_310gm} className="card-img-top" alt="Dulgold" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Dul </h5>
                                                <p className="card-text">Weight: 10.310gm</p>
                                                <p className="card-text mb-2">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                  <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Dul10_680gm} className="card-img-top" alt="Dul" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Dul</h5>
                                                <p className="card-text">Weight: 10.680gm</p>
                                                <p className="card-text mb-2">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Dul11_290gm} className="card-img-top" alt="Dul" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Dul                                     </h5>
                                                <p className="card-text">Weight: 11.290gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

           



         


 <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={Dulnew9_810gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul </h5>
                                            <p className="card-text">Weight: 9.810gm</p>
                                            <p className="card-text mb-2">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul10_090gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 10.090gm</p>
                                            <p className="card-text mb-2">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul10_130gm} className="card-img-top" alt="Dul"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 10.450gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul10_620gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Dul</h5>
                                            <p className="card-text">Weight: 10.620gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={Dul12_490g} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul </h5>
                                            <p className="card-text">Weight: 12.490gm</p>
                                            <p className="card-text mb-2">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul3_430gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 3.430gm</p>
                                            <p className="card-text mb-2">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul4_140gm} className="card-img-top" alt="Dul"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 4.140gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul4_190gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Dul</h5>
                                            <p className="card-text">Weight: 4.190gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={Dulnew4_420gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul </h5>
                                            <p className="card-text">Weight: 4.420gm</p>
                                            <p className="card-text mb-2">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul4_640gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 4.640gm</p>
                                            <p className="card-text mb-2">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul4_680gm} className="card-img-top" alt="Dul"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 4.680gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul4_780gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Dul</h5>
                                            <p className="card-text">Weight: 4.780gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={Dulnew4_800gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul </h5>
                                            <p className="card-text">Weight: 4.800gm</p>
                                            <p className="card-text mb-2">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul4_830gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 4.830gm</p>
                                            <p className="card-text mb-2">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul4_970gm} className="card-img-top" alt="Dul"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 4.970gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul5_120gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Dul</h5>
                                            <p className="card-text">Weight: 5.120gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img id="myimage" src={Dulnew5_380gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul </h5>
                                            <p className="card-text">Weight: 5.380gm</p>
                                            <p className="card-text mb-2">ID No.</p>

                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>


                                        </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul5_450gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 5.450gm</p>
                                            <p className="card-text mb-2">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul5_550gm} className="card-img-top" alt="Dul"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Dul</h5>
                                            <p className="card-text">Weight: 5.550gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul5_570gm} className="card-img-top" alt="Dul" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Dul</h5>
                                            <p className="card-text">Weight: 5.720gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

 <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                               
                                    <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img id="myimage" src={Dul9_650gm} className="card-img-top" alt="Dul" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Dul </h5>
                                                <p className="card-text">Weight: 9.650gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            

                            </div>
                        </div>
                      

                    </div>
                </div>
            </div>
         
            <br />

            <br />
        </div>
    )
}

export default Dulpage